export default {
	name: 'PetPurchases',
	components: {},
	directive: {},
	filters: {},
	mixins: [],
	props: {},
	data() {
		return {
		}
	},
	computed: {},
	watch: {
	},
	created() {
		this.$router.push('/pet-purchases/puppy-selling');
	},
	methods: {},
	// third party libraries
}